<template>
  <div class="auth-callback">
    <v-container fill-height>
      <v-row justify="center" align="center">
        <v-col cols="12" sm="8" md="6">
          <v-card class="elevation-12">
            <v-card-text class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
                :size="70"
                :width="7"
              ></v-progress-circular>
              <div class="mt-4">
                <h3>Procesando autenticación...</h3>
                <p>Por favor espere mientras verificamos sus credenciales.</p>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import authService from '@/services/authService'
import decode from 'jwt-decode'

export default {
  name: 'AuthCallback',
  async mounted() {
    try {
      // Procesar el callback de autenticación
      await this.processAuthCallback()
    } catch (error) {
      console.error('Error en callback de autenticación:', error)
      this.$router.push({ name: 'Login' })
    }
  },
  
  methods: {
    async processAuthCallback() {
      try {
        // Intentar obtener el token después del callback
        const token = await authService.tryAutoLogin()
        
        if (token) {
          // Guardar el token en el store
          this.$store.dispatch('guardarToken', token)
          
          // Redirigir al home
          this.$router.push({ name: 'Home' })
        } else {
          // No se pudo obtener el token, volver al login
          this.$router.push({ name: 'Login' })
        }
      } catch (error) {
        console.error('Error procesando callback:', error)
        this.$router.push({ name: 'Login' })
      }
    }
  }
}
</script>

<style scoped>
.auth-callback {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}
</style>
